import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchEntryBySlug } from '../lib/cms';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [footerData, setFooterData] = useState(null);

  useEffect(() => {
    async function loadFooter() {
      try {
        const data = await fetchEntryBySlug('da', 'footer');
        if (data) setFooterData(data);
      } catch (err) {
        console.error('Error loading footer CMS data:', err);
      }
    }
    loadFooter();
  }, []);

  const aboutText = footerData?.footer_about_text?.da || footerData?.footer_about_text || "Din lokale tømrer- og murerforretning i Galten og omegn. Med mere end 30 års erfaring leverer vi solidt håndværk, overholdte aftaler og professionel rådgivning.";
  const addressText = footerData?.address_label?.da || footerData?.address_label || "Filippavænget 12, 8464 Galten";
  const phoneText = footerData?.phone_label?.da || footerData?.phone_label || "20 91 00 19";
  const emailText = footerData?.email_label?.da || footerData?.email_label || "steffen@skt-byg.dk";
  const cvrText = footerData?.cvr_label?.da || footerData?.cvr_label || "30587944";
  const certTitle = footerData?.footer_certifications_title?.da || footerData?.footer_certifications_title || "Kvalitetsgaranti & Certificeringer";

  return (
    <footer className="relative bg-brand-dark text-white pt-16 pb-8 overflow-hidden">
      {/* Baggrundsbillede med mørkt overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://assets.auxodev.dk/cdn-cgi/image/width=1600,quality=70,format=auto/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/imgi-10-faa-et-godt-tilbud.jpg"
          alt="Footer baggrund"
          className="w-full h-full object-cover opacity-15"
        />
        <div className="absolute inset-0 bg-brand-dark/80 mix-blend-multiply" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-6 grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
        {/* Kolonne 1: Om os & Logo */}
        <div className="space-y-6">
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://assets.auxodev.dk/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/logo-hvid.png"
              alt="SKT Byg Logo"
              className="h-16 w-auto object-contain"
            />
          </Link>
          <p className="text-sm text-white/70 leading-relaxed">
            {aboutText}
          </p>
          <div className="pt-2">
            <a
              href="https://www.facebook.com/sktbyg/?ref=embed_page#"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 px-4 py-2 bg-[#1877F2]/20 hover:bg-[#1877F2] text-white border border-[#1877F2]/40 transition-colors duration-200 text-xs font-bold uppercase tracking-wider group"
              title="Følg SKT Byg på Facebook"
            >
              <i className="fa-brands fa-facebook text-base text-[#1877F2] group-hover:text-white transition-colors" />
              <span>Følg os på Facebook</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-[10px] opacity-70 group-hover:opacity-100 transition-opacity" />
            </a>
          </div>
        </div>

        {/* Kolonne 2: Hurtige links */}
        <div>
          <h3 className="font-display font-bold text-base tracking-wider uppercase text-white mb-6">Hurtige links</h3>
          <ul className="space-y-3 text-sm">
            <li>
              <Link to="/faa-et-tilbud" className="text-white/70 hover:text-brand-accent transition-colors duration-300">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-accent mr-2"></i>
                Få et tilbud
              </Link>
            </li>
            <li>
              <Link to="/anmeldelser" className="text-white/70 hover:text-brand-accent transition-colors duration-300">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-accent mr-2"></i>
                Anmeldelser
              </Link>
            </li>
            <li>
              <Link to="/referencegalleri" className="text-white/70 hover:text-brand-accent transition-colors duration-300">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-accent mr-2"></i>
                Galleri
              </Link>
            </li>
            <li>
              <Link to="/nyheder" className="text-white/70 hover:text-brand-accent transition-colors duration-300">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-accent mr-2"></i>
                Nyheder
              </Link>
            </li>
            <li>
              <Link to="/profil" className="text-white/70 hover:text-brand-accent transition-colors duration-300">
                <i className="fa-solid fa-chevron-right text-[10px] text-brand-accent mr-2"></i>
                Profil
              </Link>
            </li>
            <li>
              <a
                href="https://www.facebook.com/sktbyg/?ref=embed_page#"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-[#1877F2] transition-colors duration-300 flex items-center"
              >
                <i className="fa-brands fa-facebook text-xs text-[#1877F2] mr-2"></i>
                Facebook-side
              </a>
            </li>
          </ul>
        </div>

        {/* Kolonne 3: Kontakt */}
        <div>
          <h3 className="font-semibold text-white mb-6 uppercase tracking-wider text-sm">Kontaktinformation</h3>
          <ul className="space-y-4 text-white/80 text-sm">
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-map-marker-alt text-brand-accent mt-1" />
              <span>{addressText}</span>
            </li>
            <li className="flex items-center gap-3">
              <i className="fa-solid fa-phone text-brand-accent" />
              <a href="tel:20910019" className="hover:text-brand-accent transition-colors whitespace-nowrap">
                {phoneText}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <i className="fa-solid fa-envelope text-brand-accent mt-1" />
              <a href="mailto:steffen@skt-byg.dk" className="hover:text-brand-accent whitespace-nowrap">
                {emailText}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <span className="font-semibold text-white/50">CVR:</span>
              <span>{cvrText}</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Certificeringer & Samarbejdspartnere */}
      <div className="relative z-10 mx-auto max-w-7xl px-6 mb-12">
        <div className="pt-8 border-t border-white/10">
          <div className="mb-6">
            <p className="text-xs font-bold uppercase tracking-widest text-white">
              {certTitle}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {/* Junckers Certificeret Gulvlægger */}
            <Link
              to="/vi-tilbyder#junckers"
              className="group flex items-center gap-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-brand-accent/40 p-4 transition-all duration-300"
            >
              <div className="h-12 w-20 shrink-0 bg-white rounded p-1.5 flex items-center justify-center shadow-xs">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=80,format=auto/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/junckers-footer.png"
                  alt="Junckers Certificeret Gulvlægger"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <div className="min-w-0">
                <span className="block text-xs font-bold text-white group-hover:text-brand-accent transition-colors">
                  Junckers Gulvlægger
                </span>
                <span className="block text-[11px] text-white/60 truncate">
                  Op til 20 års udvidet garanti
                </span>
              </div>
            </Link>

            {/* VELUX Certificeret Montør */}
            <Link
              to="/vi-tilbyder#velux"
              className="group flex items-center gap-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-brand-accent/40 p-4 transition-all duration-300"
            >
              <div className="h-12 w-20 shrink-0 bg-white rounded p-1.5 flex items-center justify-center shadow-xs">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=80,format=auto/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/velux-certificeret-partner-logo.png"
                  alt="VELUX Certificeret Montør"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <div className="min-w-0">
                <span className="block text-xs font-bold text-white group-hover:text-brand-accent transition-colors">
                  VELUX Certificeret
                </span>
                <span className="block text-[11px] text-white/60 truncate">
                  Autoriseret dagslysmontør
                </span>
              </div>
            </Link>

            {/* Online Timeregistrering */}
            <Link
              to="/vi-tilbyder#webtid"
              className="group flex items-center gap-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-brand-accent/40 p-4 transition-all duration-300"
            >
              <div className="h-12 w-20 shrink-0 bg-white rounded p-1.5 flex items-center justify-center shadow-xs">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=200,quality=80,format=auto/assets/47bb99a3-111d-47bf-9e96-8ebfe359b0ab/eg-web.png"
                  alt="EG Webtid Online Timeregistrering"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <div className="min-w-0">
                <span className="block text-xs font-bold text-white group-hover:text-brand-accent transition-colors">
                  Online Timeregistrering
                </span>
                <span className="block text-[11px] text-white/60 truncate">
                  EG Webtid transparent styring
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Bund-bar */}
      <div className="relative z-10 mx-auto max-w-7xl px-6 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/40">
        <p>© {currentYear} SKT-BYG ApS. Alle rettigheder forbeholdes.</p>
        <a
          href="https://www.facebook.com/sktbyg/?ref=embed_page#"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-white/60 hover:text-[#1877F2] transition-colors"
        >
          <i className="fa-brands fa-facebook text-sm text-[#1877F2]"></i>
          <span>facebook.com/sktbyg</span>
        </a>
      </div>
    </footer>
  );
}
